import { log } from "@lululemon/mwa-utils";
import { Context } from "urql";
import { trackEvent, trackTargetEvent } from "../lib/analytics";
import { publicConfig } from "../util/public-config";
import { KIWI_PATH } from "./constants";

const optIntoMarketingProgramMutation = `
mutation optIntoMarketingProgram(
  $email: String!
  $preferredLanguage: String!
  $country: String!
  $acquisitionSource: String!
) {
  optIntoMarketingProgram(
    email: $email
    preferredLanguage: $preferredLanguage
    country: $country
    acquisitionSource: $acquisitionSource
    program: PRODUCT_NOTIFICATIONS
  )
}
`;

const trackEvents = (eventTrackingId) => {
  if (eventTrackingId) {
    trackEvent(eventTrackingId);
  }
  trackEvent("componentInteraction", {
    id: "NCE-1085",
    category: "email-acquisition",
    action: "email-acquisition-topnav-banner",
    attributes: {
      events: ["event5"],
    },
  });
  trackTargetEvent({
    mbox: "target-global-mbox",
    params: {
      emailSignedUp: true,
    },
  });
};

const subscribeGuestEmail = async (
  { guestEmail, language, countryCode, eventTrackingId, aquisitionSource },
  graphqlClient
) => {
  trackEvents(eventTrackingId);
  const apiHost = `${publicConfig?.apiHost}`;
  Context.url = `${apiHost}${KIWI_PATH}`;
  try {
    const response = await graphqlClient
      .mutation(
        optIntoMarketingProgramMutation,
        {
          email: guestEmail,
          preferredLanguage: language,
          country: countryCode,
          acquisitionSource: aquisitionSource,
        },
        Context
      )
      .toPromise();

    if (response.error) {
      throw response.error;
    }
  } catch (error) {
    log.error("Error adding a guest email", error?.message);
    throw error;
  }
};

export default subscribeGuestEmail;
